<template>
	<div class='knd-paragraaf knd-paragraaf-bronnen '>
		<div class='knd-paragraaf-bronnen-label'>Bronnen</div>
		<div v-html="data"></div>
	</div>
</template>

<script>

	const vueObject = {
		props: ['data'],
		methods: {}
	}

	export default vueObject;
</script>